module.exports = __webpack_public_path__ + "img/5b2a5979f0918144c4a0bb1aaae96c01.svg";